export enum ChecklistDescription {
  LICENSED_PRACTICAL_NURSE = 'Licensed Practical Nurse Licensure',
  REGISTERED_NURSE = 'Registered Nurse Licensure',
  LICENSURE = 'Licensure',
}
